// extracted by mini-css-extract-plugin
export default {"container":"styles_container__jnhB9","headingMovedDown":"styles_headingMovedDown__ElCG-","inlineLink":"styles_inlineLink__cgJYk"};